module.exports = __webpack_public_path__ + "img/customer1.94a5411a.png";